import * as constants from './actions';

const initialState = {
    isSubmitting: false,
    isPhoneLinkClicked: false
};

export default function poll(state = initialState, { type, payload }) {
    switch (type) {
        case constants.CALL_SUCCESS:
            return {
                ...state,
                completeCall: payload,
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier],
                thankYouText: payload.thankYouText,
                localRepresentativeCallState: payload.localRepresentativeState
            };
        case constants.CALL_SUBMITTING:
            return {
                ...state,
                isSubmitting: payload
            };
        case constants.SET_SUCCESS_INFO:
            return {
                ...state,
                successInfo: {
                    thankYouText: payload.thankYouText,
                    thankYouTitle: payload.thankYouTitle,
                    useLocalRepresentative: payload.useLocalRepresentative,
                    localRepresentativeState: payload.localRepresentativeState,
                    id: payload.apiRequestData ? payload.apiRequestData.id : '',
                    recipientName: payload.recipientName
                }
            };
        case constants.IS_PHONE_LINK_CLICKED:
            return {
                ...state,
                isPhoneLinkClicked: payload
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Call/reducer.js